import { useEffect, useState } from 'react';
import { Alert, AlertIcon, AlertTitle, AlertDescription, Link } from '@chakra-ui/react';
import { getBillingUsage, createPortalSession } from '../lib/api';

interface UsageData {
  posts_used: number;
  posts_included: number;
  subscription_status: string;
  overage_rate_cents: number;
}

export default function BillingBanner() {
  const [usage, setUsage] = useState<UsageData | null>(null);

  useEffect(() => {
    getBillingUsage()
      .then(setUsage)
      .catch(() => {});
  }, []);

  if (!usage) return null;

  const { subscription_status, posts_used, posts_included } = usage;

  if (subscription_status === 'past_due') {
    return (
      <Alert status="error" borderRadius="lg" mb={4}>
        <AlertIcon />
        <AlertTitle>Payment failed.</AlertTitle>
        <AlertDescription>
          Please{' '}
          <Link
            color="red.700"
            fontWeight="bold"
            textDecoration="underline"
            onClick={async () => {
              try {
                const { url } = await createPortalSession();
                window.location.href = url;
              } catch { /* noop */ }
            }}
          >
            update your payment method
          </Link>
          .
        </AlertDescription>
      </Alert>
    );
  }

  if (subscription_status === 'canceled' || subscription_status === 'inactive') {
    return (
      <Alert status="warning" borderRadius="lg" mb={4}>
        <AlertIcon />
        <AlertTitle>No active subscription.</AlertTitle>
        <AlertDescription>Subscribe to generate content.</AlertDescription>
      </Alert>
    );
  }

  if (posts_included > 0 && posts_used >= posts_included * 0.9) {
    const pct = Math.round((posts_used / posts_included) * 100);
    const rate = (usage.overage_rate_cents / 100).toFixed(2);
    return (
      <Alert status="info" borderRadius="lg" mb={4}>
        <AlertIcon />
        <AlertDescription>
          You've used {posts_used} of {posts_included} included posts ({pct}%).
          Additional posts will be billed at ${rate} each.
        </AlertDescription>
      </Alert>
    );
  }

  return null;
}
